module.exports = __webpack_public_path__ + "assets/img/domantas.eced1b33.jpg";